if($('.video-carousel-block').length){
    var itemToShow = $('.video-carousel-block .video-carousel').data('videos-to-show');
    $('.video-carousel-block .video-carousel').slick({
        adaptiveHeight: true,
        vertical: false,
        slidesToShow: itemToShow,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        rtl: window.rtl_slick,
        responsive: 
        [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}